import React from 'react';
import {
  Row,
  Col,
} from 'react-bootstrap';
import { List } from 'immutable';
import PlaceNameDisplayWrapper from '@/component/dict/simple/port/NameDisplayWrapper';
import { getDeliveryTermCs, getDeliveryTermFs } from '../../../../util/util';

export function formPortString(ports) {
  return ports.map((port, idxPort) =>
    <div key={port || idxPort} style={{ display: 'inline' }}>
      <PlaceNameDisplayWrapper
        id={port}
      />
      {idxPort + 1 < ports.size ? ', ' : ''}
    </div>);
}

export function getTransportPorts(elem, dealFrom) {
  let ports;
  switch (elem.get('transportType')) {
    case 'CONTAINER':
    case 'RAILCAR':
    case 'TRUCK':
      ports = dealFrom === 'purchase' ?
        List.of(elem.get('loadingPort'))
        : List.of(elem.get('dischargePort'));
      break;
    case 'BULK':
      ports = dealFrom === 'purchase' ?
        elem.get('vesselLoadingPorts', new List())
          .map(port => port.get('place')).filter(p => p || p === 0)
        : elem.get('vesselDischargePorts', new List())
          .map(port => port.get('place')).filter(p => p || p === 0);
      break;
    default:
      ports = dealFrom === 'purchase' ?
        elem.get('loadingports', new List())
        : elem.get('dischargeports', new List());
  }
  return ports.filter(port => port);
}

function threeSideValidationProcess(purchaseProduct, saleProduct, transport,
  isLoadingPortValidation, purchaseDTName, saleDTName) {
  let portAlert = '';
  if (!transport || !purchaseProduct || !saleProduct) {
    return portAlert;
  }
  const portTypeLabel = isLoadingPortValidation ? 'loading' : 'discharge';
  const dealType = isLoadingPortValidation ? 'Purchase' : 'Sale';
  const productToValidate = isLoadingPortValidation ? purchaseProduct : saleProduct;
  const hostPorts = Array.isArray(productToValidate.get('ports')) ?
    new List().merge(productToValidate.get('ports')) :
    productToValidate.get('ports', new List());


  const transportPorts = getTransportPorts(transport,
    isLoadingPortValidation ? 'purchase' : 'sale');

  if (!transportPorts || transportPorts.size === 0 || !hostPorts || hostPorts.siz === 0) {
    return portAlert;
  }
  if (hostPorts.filter(port => transportPorts.indexOf(port) > -1).size === 0) {
    portAlert = (<div style={{ marginBottom: '8px' }} id="port_warning">
      <Row>
        <Col xs={12}>
          The purchase delivery term is {purchaseDTName}.
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          The sale delivery term is {saleDTName}.
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          However the the {portTypeLabel} ports mismatch:
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          Transport {portTypeLabel} ports: {formPortString(transportPorts)}
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {dealType} ports: {formPortString(hostPorts)}
        </Col>
      </Row>
    </div>);
  }
  return portAlert;
}

export function threeSideValidation(deliveryTerms, purchaseProduct, saleProduct, transport) {
  if (!deliveryTerms || !purchaseProduct || !saleProduct) {
    return false;
  }
  const purchaseDTid = purchaseProduct.get('deliveryTerm');
  const saleDTid = saleProduct.get('deliveryTerm');
  if (purchaseDTid == undefined || saleDTid == undefined) {
    return false;
  }
  const purchaseDT = deliveryTerms.find(dt => dt.get('id') == purchaseDTid);
  const saleDT = deliveryTerms.find(dt => dt.get('id') == saleDTid);
  if (!saleDT || !purchaseDT) {
    return false;
  }
  const purchaseDTName = purchaseDT.get('name');
  const saleDTName = saleDT.get('name');
  const firstDTSet = getDeliveryTermCs();
  const secondDTSet = getDeliveryTermFs();
  if (firstDTSet.has(purchaseDTName) && firstDTSet.has(saleDTName)) {
    return threeSideValidationProcess(purchaseProduct, saleProduct, transport, false,
      purchaseDTName, saleDTName);
  } else if (secondDTSet.has(purchaseDTName) && secondDTSet.has(saleDTName)) {
    return threeSideValidationProcess(purchaseProduct, saleProduct, transport, true,
      purchaseDTName, saleDTName);
  }
  return false;
}
